import * as React from "react"
import { Link } from 'react-router-dom'
import styled from "styled-components"

import * as arrowPrevious from "Placements/Assets/svg/arrow-down.svg"

const BreadcrumbStyle = styled.nav`
    background-color: transparent;
    padding: 0;

    ol {
        background-color: transparent;
        padding: 0;
    }
`
const BreadcrumbItemStyle = styled.li`
    font-size: 0.8rem;
    padding: 0;
    display: inline-block !important;

    a, span, &.active {
        font-size: 0.8rem;
        color: ${props => props.theme.main.mainPurple};
        font-weight: 500;
        display: inline-block;
        margin: -1em;
        padding: 1em;
        position: relative;
        z-index: 1;
    }

    &:not(:first-child)::before {
        content: "/";
    }

    & + .breadcrumb-item.active::before {
        padding-left: .5rem;
    }
`



interface BreadcrumbProps { links: Array<{ id?: number, path: string, label: string }> }

const Breadcrumb = (props: BreadcrumbProps) => {
    const lastLink = props.links[props.links.length - 1]
    const lastPage = props.links[props.links.length - 2]

    if (window.innerWidth < 768) {
        return (
            <div className="row mb-3">
                {lastPage ?
                    <div className="col-12">
                        <BreadcrumbStyle aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <BreadcrumbItemStyle className="breadcrumb-item d-flex align-items-center">
                                    <img src={arrowPrevious} className="breadcrumb-arrow pr-3" />
                                    <Link to={lastPage.path}>
                                        Back
                                </Link>
                                </BreadcrumbItemStyle>
                            </ol>
                        </BreadcrumbStyle>
                    </div> : ''}
            </div>
        )
    }

    return (
        <div className="row" style={{ margin: '1rem 0' }}>
            <div>
                <BreadcrumbStyle aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                        {
                            props.links
                                .filter((link: any) => link !== lastLink)
                                .map((link: any, key) => {
                                    return (
                                        <BreadcrumbItemStyle key={key} className="breadcrumb-item">
                                            {link.path ?
                                                <Link to={link.path}>
                                                    {link.label}
                                                </Link>
                                                :
                                                <span>
                                                    {link.label}
                                                </span>
                                            }
                                            {/*&nbsp;&nbsp;&nbsp;/ */}
                                        </BreadcrumbItemStyle>
                                    )
                                })
                        }
                        <BreadcrumbItemStyle className="breadcrumb-item active" aria-current="page">
                            {lastLink.label}
                        </BreadcrumbItemStyle>
                    </ol>
                </BreadcrumbStyle>
            </div>
        </div>
    )

}

export default Breadcrumb
